// Причины отклонения заявки на вывод. Сотрудник выбирает причину на русском,
// игроку текст уходит на языке его бренда: MXN — испанский, BRL — английский +
// португальский, для остальных валют — английский.
export const OTHER_REASON = 'OTHER';

// Причина «Высокая нагрузка / Изменение суммы» — в текст подставляются сумма и валюта.
export const AMOUNT_REASON = 'HIGH_LOAD_NEW_AMOUNT';

export const WITHDRAW_DENY_REASONS = [
  {
    value: 'WRONG_REQUISITES',
    text: 'У игрока ошибка в реквизитах',
    en: 'Please check and confirm your payment details.',
    pt: 'Por favor, verifique e confirme os dados do seu pagamento.',
    es: 'Por favor, verifique y confirme sus datos de pago.',
  },
  {
    value: 'METHOD_CHANGED',
    text: 'Смена метода вывода',
    en: 'Your withdrawal method has been updated. Kindly submit a new request if required.',
    pt: 'O seu método de saque foi atualizado. Por favor, envie um novo pedido, se necessário.',
    es: 'Su método de retiro ha sido actualizado. Por favor, envíe una nueva solicitud si es necesario.',
  },
  {
    value: 'CONTACT_SUPPORT',
    text: 'Требуется объяснение / Связь с поддержкой',
    en: 'Please contact our support team for assistance.',
    pt: 'Por favor, entre em contato com nossa equipe de suporte para obter assistência.',
    es: 'Por favor, contacte nuestro equipo de soporte para obtener asistencia.',
  },
  {
    // Вместо {amount} подставляются сумма и валюта, которые вписывает сотрудник.
    value: AMOUNT_REASON,
    text: 'Высокая нагрузка / Изменение суммы',
    en: 'Due to high volume in our payment systems, please submit a new withdrawal request for {amount}. Contact support if needed.',
    pt: 'Devido ao alto volume em nossos sistemas de pagamento, pedimos que envie um novo pedido de saque de {amount}. Entre em contato com o suporte, se necessário.',
    es: 'Debido a la alta carga en nuestros sistemas de pago, por favor, envíe una nueva solicitud de retiro por {amount}. Contacte soporte si es necesario.',
  },
  {
    value: 'RECREATE_REQUEST',
    text: 'Необходимость пересоздать заявку',
    en: 'Your withdrawal request was unsuccessful. Please create a new request.',
    pt: 'O seu pedido de saque não foi processado com sucesso. Por favor, crie um novo pedido.',
    es: 'Su solicitud de retiro no fue procesada. Por favor, cree una nueva solicitud.',
  },
  {
    value: 'VERIFICATION_REQUIRED',
    text: 'Необходимо пройти верификацию',
    en: 'To proceed, please complete the account verification by submitting copies of your identity documents.',
    pt: 'Para prosseguir, por favor, conclua a verificação da conta, enviando cópias dos seus documentos de identidade.',
    es: 'Para continuar, por favor, complete la verificación de la cuenta enviando copias de sus documentos de identidad.',
  },
  {
    value: 'VIDEO_VERIFICATION_REQUIRED',
    text: 'Необходимо пройти видео-верификацию',
    en: 'Kindly complete the mandatory video verification process. Please contact our support service to arrange this.',
    pt: 'Solicitamos que conclua o processo obrigatório de verificação por vídeo. Por favor, entre em contato com nosso serviço de suporte para agendá-lo.',
    es: 'Le solicitamos que complete el proceso obligatorio de verificación por video. Por favor, contacte nuestro servicio de soporte para coordinarlo.',
  },
  {
    // Пустая строка — сотрудник вписывает причину сам.
    value: OTHER_REASON,
    text: 'Другое',
    en: '',
    pt: '',
    es: '',
  },
];

// Текст причины для игрока в зависимости от валюты заявки. Вместо {amount}
// подставляются сумма и валюта, пока они не вписаны — остаётся "...".
export function buildDenyReasonText(reason, purseType, amountText) {
  if (!reason || reason.value === OTHER_REASON) return '';

  let text;
  switch (purseType) {
    case 'MXN':
      text = reason.es;
      break;
    case 'BRL':
      text = `${reason.en}\n${reason.pt}`;
      break;
    default:
      text = reason.en;
  }

  return text.replace(/\{amount\}/g, amountText || '...');
}

export default {
  WITHDRAW_DENY_REASONS,
  OTHER_REASON,
  AMOUNT_REASON,
  buildDenyReasonText,
};
